import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cartPersonsRowsPerPage: 10,
};

const cartPersonSlice = createSlice({
  name: "cartPersons",
  initialState,
  reducers: {
    setCartPersonsRowsPerPage(state, action) {
      state.cartPersonsRowsPerPage = action.payload;
    },
    clearCartPersonsRowsPerPage(state) {
      state.cartPersonsRowsPerPage = 10;
    },
  },
});

export const { setCartPersonsRowsPerPage, clearCartPersonsRowsPerPage } =
  cartPersonSlice.actions;
export default cartPersonSlice.reducer;
